import { PipeableArray } from '../base/pipeable/pipeable_array.js';
import { FoodMenuFoods } from './food_menu_foods.js';

class FoodListPipeableArray extends PipeableArray {
  static Sort = (a, b) => a.idx - b.idx;
}

class FoodMenuPipeables {
  get dates() {
    if (!this.#dates) {
      this.#dates = new PipeableArray();
      this.#dates.set(this.#caster.dates);
    }
    return this.#dates;
  }

  get foods() {
    if (!this.#foods) {
      this.#foods = new FoodMenuFoods();
    }
    return this.#foods;
  }

  getFoodList(day, meal) {
    let mealFoodMap = this.#foodLists.get(day);
    if (!mealFoodMap) {
      this.#foodLists.set(day, (mealFoodMap = new Map()));
    }
    let foodList = mealFoodMap.get(meal);
    if (!foodList) {
      mealFoodMap.set(meal, (foodList = new FoodListPipeableArray()));
      foodList.set(this.#caster.getFoodList(day, meal));
    }
    return foodList;
  }

  getFoodListCached(day, meal) {
    let pipeables = this.#foodLists.get(day);
    return pipeables && pipeables.get(meal);
  }

  datesChange() {
    if (this.#dates) {
      this.#dates.set(this.#caster.dates);
    }
  }

  foodListsChange() {
    let pipeablesToRemove = [];
    for (let [day, mealFoodMap] of this.#foodLists.entries()) {
      for (let [meal, foodList] of mealFoodMap) {
        let list = this.#caster.getFoodList(day, meal);
        if (list) {
          foodList.set(list);
        } else {
          pipeablesToRemove.push([day, meal]);
        }
      }
    }

    for (let [day, meal] of pipeablesToRemove) {
      let mealFoodMap = this.#foodLists.get(day);
      mealFoodMap.delete(meal);
      if (mealFoodMap.size == 0) {
        this.#foodLists.delete(day);
      }
    }
  }

  foodListChange(day, meal) {
    let mealFoodMap = this.#foodLists.get(day);
    if (mealFoodMap) {
      let foodList = mealFoodMap.get(meal);
      if (foodList) {
        let list = this.#caster.getFoodList(day, meal);
        foodList.set(list);
      }
    }
  }

  constructor(caster) {
    this.#caster = caster;
  }

  #caster;

  #dates;
  #foods;
  #foodLists = new Map();
}

export { FoodMenuPipeables };
